import AModal from '@/components/A/AModal/AModal'
import styles from './ChangeCorpNameModal.module.less'
import { useTranslation } from 'react-i18next'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { FormItem } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import AInput from '@/components/A/AInput/AInput'
import { useState } from 'react'


interface Props {
  corpName: string
  onConfirm?: (corpName: string) => void
  onCancel?: () => void
}


function ChangeCorpNameModal(props: Props) {
  const { t } = useTranslation()
  const modal = useModal()
  const [errMsg, setErrMsg] = useState('')
  const [corpName, setCorpName] = useState(props.corpName)

  const validator = (corpName: string) => {
    if (!corpName) {
      return t('dashboard.accountPage.message.pleaseEnterTheCorpName')
    }
    return ''
  }

  const handleCancel = () => {
    props.onCancel?.()
    modal.hide()
  }
  const handleConfirm = () => {
    const errMsg = validator(corpName)
    if (errMsg) {
      setErrMsg(errMsg)
      return
    }
    props.onConfirm?.(corpName)
    modal.hide()
  }


  return <AModal
    testId='account-change-corp-name-modal'
    width={450}
    open={modal.visible}
    className={styles.changeCorpNameModal}
    title={t('dashboard.accountPage.message.changeCorpNameTitle')}
    confirmText={t('dashboard.accountPage.message.passwordConfirm')}
    cancelText={t('dashboard.accountPage.message.passwordCancel')}
    onCancel={handleCancel}
    onConfirm={handleConfirm}
    afterClose={() => {
      modal.remove()
    }}
  >
    <div>
      <FormItem
        label={t('dashboard.accountPage.message.changeCorpNameLabel')}
        error={Boolean(errMsg)}
        errorMsg={errMsg}
      >
        <AInput testId='account-change-corp-name-input' placeholder={t('dashboard.accountPage.message.pleaseEnterTheCorpName')}
          value={corpName}
          onChange={(e) => {
            setCorpName(e.target.value)
            setErrMsg('')
          }} />
      </FormItem>
    </div>
  </AModal>
}

export default NiceModal.create(ChangeCorpNameModal)
